import { createAsyncLoadedAction } from 'swag-client-common/utils/create-async-loaded-actions.utils';
import { publicGoodieGiveawayApi } from 'swag-client-common/api/goodie-giveaway.api';
import { showNotification } from 'swag-client-common/redux/notification/notification.actions';
import { USER_ERROR_ACTIONS } from 'swag-common/constants/user-actions';
import { PREFIX as GLOBAL_PREFIX } from '../goodie-giveaway.actions';
const PREFIX = `${GLOBAL_PREFIX}CATEGORIES_`;
export const GET_ALL_SUCCESS = `${PREFIX}GET_ALL_SUCCESS`;
export const GET_ALL_FAILURE = `${PREFIX}GET_ALL_FAILURE`;
export const getAllCategories = createAsyncLoadedAction({
  fn: publicGoodieGiveawayApi.getAllCategories,
  success: list => ({
    type: GET_ALL_SUCCESS,
    payload: {
      list
    }
  }),
  error: error => ({
    type: GET_ALL_FAILURE,
    payload: {
      error
    }
  }),
  postError: dispatch => {
    dispatch(showNotification({
      text: USER_ERROR_ACTIONS.SOMETHING_WENT_WRONG
    }));
  }
});